/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import './image-selector.less';

const ImageSelector = ({ images, activeImage, onImageClick }) => {
  return (
    <div className="-wa-edit-controls__image-selector">
        { images.map( image => {
          const imageWrapperClassnames = classnames({
            '-wa-edit-controls-image-wrapper': true,
            '-wa-edit-controls-image-wrapper-active': image === activeImage
          });

          const imageName = image.replace(/^.*?\/([^\/]+)$/, '$1');

          return (
            <div
              key={imageName}
              onClick={ () => onImageClick(image)}
              className="-wa-edit-controls-image-selector-item"
            >
              <div className="-wa-edit-controls-image-item-selector-inner">
                <div className={imageWrapperClassnames}>
                  <div className="-wa-edit-controls-image-inner-wrapper">
                    <img className="-wa-edit-controls-image-img" src={image} alt="" />
                  </div>
                </div>
                <div className="-wa-edit-controls-title-wrapper">
                  <div className="-wa-edit-controls-title-inner">
                    <div className="-wa-edit-controls-title-text">{imageName}</div>
                  </div>
                </div>
              </div>
            </div>);
          }
        )}
    </div>
  );
};

ImageSelector.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeImage: PropTypes.string.isRequired,
  onImageClick: PropTypes.func.isRequired
};

export default ImageSelector;